/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step4_DescInputs */

const et_process_step4_desc = /** @type {(inputs: Process_Step4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jälgime asjakohaseid andmeid, et näha, mis tegelikult toimib, ja teeme seda rohkem.`)
};

const en_process_step4_desc = /** @type {(inputs: Process_Step4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We track relevant data to see what really works, and do more of it.`)
};

/**
* | output |
* | --- |
* | "We track relevant data to see what really works, and do more of it." |
*
* @param {Process_Step4_DescInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step4_desc = /** @type {((inputs?: Process_Step4_DescInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step4_DescInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step4_desc(inputs)
	return en_process_step4_desc(inputs)
});